export enum BillingTableRowType {
    CurrentBalance = 1,
    TuitionFees = 2,
    NextVoucher = 3,
    LastPaymentMade = 4
}